export default "__VITE_ASSET__W4vdXiNI__"